import { render, staticRenderFns } from "./WelcomePopup.vue?vue&type=template&id=4aad7d7c&scoped=true&"
import script from "./WelcomePopup.vue?vue&type=script&lang=js&"
export * from "./WelcomePopup.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePopup.vue?vue&type=style&index=0&id=4aad7d7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad7d7c",
  null
  
)

export default component.exports